import { MasterInstance } from "@/instance/axios";
import { createMutationKeys, createQueryKeys } from "@lukemorales/query-key-factory";
import {
  MasterApiPrintersGetRequest,
  MasterApiPrintersPostRequest,
  MasterApiPrintersPrinterIdDeleteRequest,
  MasterApiPrintersPrinterIdGetRequest,
  MasterApiPrintersPrinterIdPutRequest,
} from "@sizlcorp/sizl-api-document/dist/models";

export const PRINTER_QUERY_KEY = "printer";

export const printer = createQueryKeys(PRINTER_QUERY_KEY, {
  all: null,
  get: (params: MasterApiPrintersGetRequest) => {
    // const queryParams = { ...params };
    const queryParams = {
      ...params,
      query: JSON.stringify({ $and: params?.query }),
      sort: params.sort?.length ? params.sort : "-id",
    }; // 프린터 조회 시 기본 정렬 표시

    return {
      queryKey: [queryParams, JSON.stringify(queryParams)],
      queryFn: () => MasterInstance.printersGet(queryParams),
    };
  },
  detail: (params: MasterApiPrintersPrinterIdGetRequest) => {
    return {
      queryKey: [params.printerId],
      queryFn: () => MasterInstance.printersPrinterIdGet(params),
    };
  },
});

export const mutatePrinter = createMutationKeys(PRINTER_QUERY_KEY, {
  create: (params: MasterApiPrintersPostRequest) => ({
    mutationKey: [params.printersGetRequest],
    mutationFn: () => MasterInstance.printersPost(params),
  }),
  update: (params: MasterApiPrintersPrinterIdPutRequest) => ({
    mutationKey: [params.printersGetRequest],
    mutationFn: () => MasterInstance.printersPrinterIdPut(params),
  }),
  delete: (params: MasterApiPrintersPrinterIdDeleteRequest) => ({
    mutationKey: [params.printerId],
    mutationFn: () => MasterInstance.printersPrinterIdDelete(params),
  }),
});
